import React from "react";
import { useLocation } from "react-router-dom";
import PrisonParoleDetailInfo from "../../components/Detail/_PrisonParoleDetailInfo";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

  
function PrisonParoleDetail() {
    let query = useQuery();

    return (
        <div>
            <PrisonParoleDetailInfo ID={query.get("ID")} department={query.get("Dept")}/>
        </div>
    );
}

export default PrisonParoleDetail;